import type {
  ModalSize,
} from './types';

const DEFAULT: ModalSize = 'default';
const TINY: ModalSize = 'tiny';
const SMALL: ModalSize = 'small';
const LARGE: ModalSize = 'large';

export const modalSizes = {
  DEFAULT,
  TINY,
  SMALL,
  LARGE,
} satisfies Record<string, ModalSize>;
